import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IMotorProduct, IProductQueryParams } from '@inshuwa-client/models';

export interface IProductsService {
  getAllMotorProducts(query?: IProductQueryParams): Observable<IMotorProduct[]>;

  deleteProduct(id: number): Observable<unknown>;
}

export const IProductsServiceToken = new InjectionToken<IProductsService>(
  'IProductsServiceToken'
);
